export const FETCH_SITEGROUP_WITH_SITES_AND_WAREHOUSE_LOADING =
  'FETCH_SITEGROUP_WITH_SITES_AND_WAREHOUSE_LOADING';
export const SITEGROUP_WITH_SITES_AND_WAREHOUSE_DATA =
  'SITEGROUP_WITH_SITES_AND_WAREHOUSE_DATA';
export const FETCH_SITEGROUP_WITH_SITES_AND_WAREHOUSE_LOADING_ERROR =
  'FETCH_SITEGROUP_WITH_SITES_AND_WAREHOUSE_LOADING_ERROR';
export const FETCH_SITE_GROUP_WAREHOUSE_LOADING =
  'FETCH_SITEGROUP_WAREHOUSE_LOADING';
export const FETCH_SITE_GROUP_WAREHOUSE_LOADING_ERROR =
  'FETCH_SITEGROUP_WAREHOUSE_LOADING_ERROR';
export const SITE_GROUP_WAREHOUSE_DATA = 'SITE_GROUP_WAREHOUSE_DATA';
export const CLEAR_ERROR_MESSAGES = 'CLEAR_ERROR_MESSAGES';
export const SUBMITTING_ORDER_PREFERENCE_LOADING =
  'SUBMITTING_SITE_GROUP_ORDER_PREFERENCE_LOADING';
export const SUBMITTED_ORDER_PREFERENCE_DATA =
  'SUBMITTED_SITE_GROUP_ORDER_PREFERENCE_DATA';
export const SUBMITTING_ORDER_PREFERENCE_LOADING_ERROR =
  'SUBMITTING_SITE_GROUP_ORDER_PREFERENCE_LOADING_ERROR';
export const CLEAR_SUBMIT_ERROR = 'CLEAR_SUBMIT_ERROR';



// WEBPACK FOOTER //
// ./src/pages/utilities/state/assignorderpreference/types.js